import { UserPermission } from '@ui/shared/models';

export const isAgent = (permissions: UserPermission[]) =>
  permissions.length > 1 &&
  !permissions.includes(UserPermission.ADMINISTRATION);

export const isAdmin = (permissions: UserPermission[]) =>
  permissions?.includes(UserPermission.ADMINISTRATION);
